import React, { Fragment } from 'react';
import * as Actions from 'projects/components/list/actions';

const ProjectsActions = ({ company, subcompany, permissions, project, handleToggle }) => {
  return (
    <Fragment>
      {permissions['acl.projects.toggle'] && (
        <Actions.Toggle project={project} handleClick={handleToggle} />
      )}

      {permissions['acl.projects.update'] && (
        <Actions.Edit
          company={company}
          subcompany={subcompany}
          project={project}
          handleClick={handleToggle}
        />
      )}
    </Fragment>
  );
};

export default ProjectsActions;



// WEBPACK FOOTER //
// src/modules/secured/modules/projects/components/list/ProjectsActions.js